import { render, staticRenderFns } from "./masterInfo.vue?vue&type=template&id=f1226c52&"
import script from "./masterInfo.vue?vue&type=script&lang=js&"
export * from "./masterInfo.vue?vue&type=script&lang=js&"
import style0 from "./masterInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports